/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { theme } from "@nordcloud/gnui";
import {
  useApplicationsCountQuery,
  useDriftedResourcesCountQuery,
} from "~/generated/graphql";
import { BrickLoader, UniversalWrap } from "~/components";
import { ROUTES } from "~/routing/routes";
import { HomepageColumn } from "../HomepageColumn";

export function ApplicationStats() {
  const {
    data: dataApplicationsCount,
    loading: loadingApplicationsCount,
    error: errorApplicationsCount,
  } = useApplicationsCountQuery();
  const {
    data: dataDriftedResourcesCount,
    loading: loadingDriftedResourcesCount,
    error: errorDriftedResourcesCount,
  } = useDriftedResourcesCountQuery();

  const applicationsCount =
    dataApplicationsCount?.applicationsPaginated?.count ?? 0;
  const driftedResourcesCount =
    dataDriftedResourcesCount?.driftedResources?.count ?? 0;

  return (
    <UniversalWrap
      loaderProps={{
        loading: loadingApplicationsCount && loadingDriftedResourcesCount,
        Component: BrickLoader,
        viewBox: "0 0 5 1",
        backgroundColor: theme.color.background.ui01,
      }}
      errorProps={{
        error: errorApplicationsCount ?? errorDriftedResourcesCount,
      }}
    >
      <HomepageColumn
        heading="Applications"
        links={[
          {
            label: `All applications`,
            url: ROUTES.applications.index,
            count: loadingApplicationsCount ? " " : applicationsCount,
          },
          {
            label: "Allocation drifts",
            url: ROUTES.estateRecords.drift,
            count: loadingDriftedResourcesCount ? " " : driftedResourcesCount,
            danger: true,
          },
        ]}
      />
    </UniversalWrap>
  );
}
